import { collection, doc } from "firebase/firestore";
import { db } from "@/lib/firebase";

export function seatingPlansCol(weddingId: string) {
  return collection(db, "weddings", weddingId, "seatingPlans");
}

export function seatingPlanRef(weddingId: string, planId: string) {
  return doc(db, "weddings", weddingId, "seatingPlans", planId);
}

export function planTablesCol(weddingId: string, planId: string) {
  return collection(db, "weddings", weddingId, "seatingPlans", planId, "tables");
}

export function planTableRef(weddingId: string, planId: string, tableId: string) {
  return doc(db, "weddings", weddingId, "seatingPlans", planId, "tables", tableId);
}

export function planRoomElementsCol(weddingId: string, planId: string) {
  return collection(db, "weddings", weddingId, "seatingPlans", planId, "roomElements");
}

export function planRoomElementRef(weddingId: string, planId: string, elementId: string) {
  return doc(db, "weddings", weddingId, "seatingPlans", planId, "roomElements", elementId);
}

/** Legacy root paths — used only during migration reads. */
export function legacyTablesCol(weddingId: string) {
  return collection(db, "weddings", weddingId, "tables");
}

export function legacyRoomElementsCol(weddingId: string) {
  return collection(db, "weddings", weddingId, "roomElements");
}

export function weddingRef(weddingId: string) {
  return doc(db, "weddings", weddingId);
}

export function guestRef(weddingId: string, guestId: string) {
  return doc(db, "weddings", weddingId, "guests", guestId);
}
